// SOĞANLI BİTKİLER - bitkiVeritabani7.js
// Nymphaea, Aponogeton, Crinum ve diğer soğanlı türler (17 bitki)

export const soganlliBitkiler = [
  // ==================== NYMPHAEA (Nilüfer) ====================
  {
    id: 'nymphaea-lotus-red',
    isim: 'Kırmızı Kaplan Nilüfer',
    latince: 'Nymphaea lotus Red',
    resim: '/images/bitkiler/nymphaea-lotus-red.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Afrika',
    uzunluk: '20-50 cm',
    genislik: '25-50 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan / Odak noktası',
    aciklama: 'Kırmızı benekli yapraklar. Yüzey yaprakları kesilmeli.'
  },
  {
    id: 'nymphaea-lotus-green',
    isim: 'Yeşil Kaplan Nilüfer',
    latince: 'Nymphaea lotus Green',
    resim: '/images/bitkiler/nymphaea-lotus-green.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Afrika',
    uzunluk: '20-50 cm',
    genislik: '25-50 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan / Odak noktası',
    aciklama: 'Yeşil yapraklı versiyon. Kırmızıdan biraz daha kolay.'
  },
  {
    id: 'nymphaea-micrantha',
    isim: 'Cüce Nilüfer',
    latince: 'Nymphaea micrantha',
    resim: '/images/bitkiler/nymphaea-micrantha.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Batı Afrika',
    uzunluk: '15-30 cm',
    genislik: '15-30 cm',
    sicaklik: '24-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Daha küçük boyutlu nilüfer. Yaprak üstünde yavru bitki üretir.'
  },
  {
    id: 'nymphaea-gardneriana-santarem',
    isim: 'Santarem Nilüfer',
    latince: 'Nymphaea gardneriana Santarem',
    resim: '/images/bitkiler/nymphaea-gardneriana-santarem.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Brezilya',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '24-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan',
    aciklama: 'Kırmızı-mor yapraklı nadir ve zor nilüfer.'
  },

  // ==================== APONOGETON ====================
  {
    id: 'aponogeton-boivinianus',
    isim: 'Boivin Aponogeton',
    latince: 'Aponogeton boivinianus',
    resim: '/images/bitkiler/aponogeton-boivinianus.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Madagaskar',
    uzunluk: '30-60 cm',
    genislik: '25-40 cm',
    sicaklik: '22-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan / Odak noktası',
    aciklama: 'Kabartmalı koyu yeşil yapraklar. Dinlenme dönemi gerektirebilir.'
  },
  {
    id: 'aponogeton-crispus',
    isim: 'Dalgalı Aponogeton',
    latince: 'Aponogeton crispus',
    resim: '/images/bitkiler/aponogeton-crispus.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '25-50 cm',
    genislik: '15-30 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Dalgalı kenarlı yapraklar. Kolay ve hızlı büyür.'
  },
  {
    id: 'aponogeton-ulvaceus',
    isim: 'Ulvaceus Aponogeton',
    latince: 'Aponogeton ulvaceus',
    resim: '/images/bitkiler/aponogeton-ulvaceus.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Madagaskar',
    uzunluk: '30-60 cm',
    genislik: '20-40 cm',
    sicaklik: '22-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Açık yeşil şeffaf dalgalı yapraklar. Çok dekoratif.'
  },
  {
    id: 'aponogeton-longiplumulosus',
    isim: 'Uzun Tüylü Aponogeton',
    latince: 'Aponogeton longiplumulosus',
    resim: '/images/bitkiler/aponogeton-longiplumulosus.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Madagaskar',
    uzunluk: '30-60 cm',
    genislik: '20-35 cm',
    sicaklik: '22-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan',
    aciklama: 'Dalgalı kahverengi-yeşil yapraklar.'
  },
  {
    id: 'aponogeton-madagascariensis',
    isim: 'Madagaskar Dantel Bitkisi',
    latince: 'Aponogeton madagascariensis',
    resim: '/images/bitkiler/aponogeton-madagascariensis.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Madagaskar',
    uzunluk: '30-60 cm',
    genislik: '20-40 cm',
    sicaklik: '18-24°C',
    ph: '6.0-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Çok zor',
    konum: 'Odak noktası',
    aciklama: 'İskelet yapraklı efsanevi bitki. Serin yumuşak su ve güçlü akıntı gerektirir.'
  },
  {
    id: 'aponogeton-rigidifolius',
    isim: 'Sert Yapraklı Aponogeton',
    latince: 'Aponogeton rigidifolius',
    resim: '/images/bitkiler/aponogeton-rigidifolius.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Sri Lanka',
    uzunluk: '30-60 cm',
    genislik: '20-35 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Koyu yeşil dar uzun yapraklar. Dinlenme dönemine girmez.'
  },
  {
    id: 'aponogeton-capuronii',
    isim: 'Capuron Aponogeton',
    latince: 'Aponogeton capuronii',
    resim: '/images/bitkiler/aponogeton-capuronii.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Madagaskar',
    uzunluk: '20-40 cm',
    genislik: '15-30 cm',
    sicaklik: '22-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Dalgalı kemerli yapraklar. Nadir tür.'
  },

  // ==================== CRINUM ====================
  {
    id: 'crinum-calamistratum',
    isim: 'Afrika Soğan Bitkisi',
    latince: 'Crinum calamistratum',
    resim: '/images/bitkiler/crinum-calamistratum.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Kamerun',
    uzunluk: '60-120 cm',
    genislik: '30-60 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan / Odak noktası',
    aciklama: 'Çok uzun spiral yapraklar. Büyük akvaryumlar için.'
  },
  {
    id: 'crinum-natans',
    isim: 'Geniş Yapraklı Crinum',
    latince: 'Crinum natans',
    resim: '/images/bitkiler/crinum-natans.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Batı Afrika',
    uzunluk: '50-100 cm',
    genislik: '40-70 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Arka plan / Odak noktası',
    aciklama: 'Geniş dalgalı yapraklar. Çok büyük bitki.'
  },
  {
    id: 'crinum-thaianum',
    isim: 'Tayland Soğan Bitkisi',
    latince: 'Crinum thaianum',
    resim: '/images/bitkiler/crinum-thaianum.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Tayland',
    uzunluk: '100-200 cm',
    genislik: '50-80 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'En kolay Crinum. Çok uzun şerit yapraklar.'
  },

  // ==================== DİĞER SOĞANLI BİTKİLER ====================
  {
    id: 'ottelia-alismoides',
    isim: 'Ottelia',
    latince: 'Ottelia alismoides',
    resim: '/images/bitkiler/ottelia-alismoides.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'High Tech',
    habitat: 'Asya, Afrika, Avustralya',
    uzunluk: '20-50 cm',
    genislik: '20-40 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Zor',
    konum: 'Orta plan / Odak noktası',
    aciklama: 'Geniş şeffaf yapraklar. Zor ama çok güzel.'
  },
  {
    id: 'zephyranthes-candida',
    isim: 'Beyaz Yağmur Zambağı',
    latince: 'Zephyranthes candida',
    resim: '/images/bitkiler/zephyranthes-candida.jpg',
    kategori: 'Soğanlı Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '15-30 cm',
    genislik: '10-20 cm',
    sicaklik: '18-26°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Çim benzeri yapraklar. Su üstüne çıkarsa çiçek açar.'
  }
];

export default soganlliBitkiler;